import { render, staticRenderFns } from "./ChatDetail.vue?vue&type=template&id=2a2f6c30&scoped=true"
import script from "./ChatDetail.vue?vue&type=script&lang=js"
export * from "./ChatDetail.vue?vue&type=script&lang=js"
import style0 from "./ChatDetail.vue?vue&type=style&index=0&id=2a2f6c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2f6c30",
  null
  
)

export default component.exports